import {DatePicker, LocalizationProvider} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, MenuItem, Paper, Switch, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import {withStyles} from "@mui/styles";
import axios from "axios";
import * as React from "react";
import {Config} from "../../config/config";
import {Helpers} from "../../utils/helpers";
import {PopupMessage} from "../../utils/message";
import VisibilityIcon from '@mui/icons-material/Visibility';
import {LoadingIndicator} from "../../components/LoadingIndicator";

export class PlayerSessiontMain extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.state = {
            loading: false,
            userId: this.props.playerId,
            filter: {
                date: new Date(),
            },
            sessions: [],
            session: {
                key: "",
                data: []
            },
            dialog: {
                open: false,
                data: {}
            },
            dataDialog: {
                open: false,
                data: ""
            }
        };
    }

    componentDidMount() {
        this.fetchSessions();
    }

    async fetchSessions() {
        const {filter} = this.state;
        const {userId} = this.state;

        this.setState({
            loading: true,
        });

        const url = `${Config.getInstance.apiUrl}/api/users/user_sessions/${userId}`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        const params = {
            date: filter.date
        }

        const response = await axios.get(url, {headers, params});
        const data = response.data;
        const success = data.success;

        this.setState({
            loading: false,
        });

        if (success) {
            const files = data.files;

            this.setState({
                sessions: files,
            });
        } else {
            console.log(`Failed to fetch sessions: ${data.message}`);
            PopupMessage.error(`Failed to fetch sessions: ${data.message}`);
        }
    }

    fetchSessionData = async (key: string) => {
        const {session} = this.state;

        session.key = key;

        this.setState({
            session,
            loading: true
        });
        const url = `${Config.getInstance.apiUrl}/api/users/user_session`;

        const headers = {
            Authorization: Helpers.getSessionId(),
        };

        const params = {
            key
        }

        const response = await axios.get(url, {headers, params});

        const data = response.data;

        this.setState({
            loading: false,
        });

        if (data.success) {
            const sessionData = data.sessionData;

            session.data = sessionData;

            this.setState({
                session,
            });

            this.onDialogOpen(sessionData);
        } else {
            console.log(`Failed to fetch session data: ${data.message}`);
            PopupMessage.error(`Failed to fetch session data: ${data.message}`);
        }
    }

    handleChangeTime = (key: string, value: any) => {
        const {filter} = this.state;
        filter[key] = value;
        this.setState({
            filter
        });
    }

    onDataDialogClose = () => {
        const {dataDialog} = this.state;

        dataDialog.open = false;

        this.setState({
            dataDialog
        });
    }

    onDataDialogOpen = (data: any) => {
        const {dataDialog} = this.state;

        dataDialog.open = true;
        dataDialog.data = data;

        this.setState({
            dataDialog
        });
    }

    onDialogClose = () => {
        const {dialog} = this.state;

        dialog.open = false;

        this.setState({
            dialog
        });
    }

    onDialogOpen = (data: any) => {
        const {dialog} = this.state;

        dialog.open = true;
        dialog.data = data;

        this.setState({
            dialog
        });
    }

    showPopup(message: string) {
        PopupMessage.success(message);
    }

        copyToClipboard = async (text) => {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    renderDataDialog() {
        const {dataDialog} = this.state;
        const {data} = dataDialog || "Nothing to show";

        return <Dialog
            open={dataDialog.open}
            onClose={this.onDataDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle>Incoming Data</DialogTitle>
            <DialogContent>
                <Button
                    disableElevation
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        this.copyToClipboard(data);
                    }}
                >
                    Copy to clipboard
                </Button>
                <TextField
                    id="outlined-multiline-static"
                    multiline
                    rows={10}
                    defaultValue={data}
                    variant="outlined"
                    fullWidth
                />
            </DialogContent>
        </Dialog>
    }

    renderDialog() {
        const {dialog} = this.state;
        const {data} = dialog || {};
        const {actions} = data || [];

        return <Dialog
            open={dialog.open}
            onClose={this.onDialogClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            fullWidth={true}
            maxWidth="lg"
        >
            <DialogTitle>Session Data</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {`UserID: ${data.id}`}
                </DialogContentText>

                <DialogContentText>
                    {`Name: ${data.username}`}
                </DialogContentText>

                <DialogContentText>
                    {`DeviceID: ${data.device_id}`}
                </DialogContentText>

                <DialogContentText>
                    {`Session Start: ${data.session_start}`}
                </DialogContentText>

                <DialogContentText>
                    {`Session End: ${data.session_end}`}
                </DialogContentText>

                <DialogContentText>
                    {`Actions:`}
                </DialogContentText>

                {actions && actions.length > 0 ? <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>#</TableCell>
                            <TableCell>Time</TableCell>
                            <TableCell>Method</TableCell>
                            <TableCell>Gold</TableCell>
                            <TableCell>Oil</TableCell>
                            <TableCell>Ruby</TableCell>
                            <TableCell>Data</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            actions.map((action: any, index: number) => {
                                return <TableRow key={index}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{action.time}</TableCell>
                                    <TableCell>{action.method}</TableCell>
                                    <TableCell>{action.honey}</TableCell>
                                    <TableCell>{action.flowers}</TableCell>
                                    <TableCell>{action.rubies}</TableCell>
                                    <TableCell>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => {
                                                this.onDataDialogOpen(JSON.stringify(action.incoming_data));
                                            }}
                                        >
                                            <VisibilityIcon />
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            })
                        }
                    </TableBody>
                </Table> : <Typography>No actions found</Typography>}
            </DialogContent>
        </Dialog>
    }

    renderFilter() {
        const style = {
            // height: '100px',
            padding: '10px',
            width: '100%',
            // backgroundColor: "black",
        } as React.CSSProperties;

        const {filter} = this.state;

        return <Paper style={style}>
            <Grid container spacing={2}>
                <Grid item sm={2}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DatePicker
                            label="Date"
                            value={filter.date}
                            onChange={(e) => this.handleChangeTime("date", e)}
                            renderInput={(params) => <TextField {...params} size="small" />}
                        />
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            this.fetchSessions();
                        }}
                    >
                        Load
                    </Button>
                </Grid>
            </Grid>
        </Paper>
    }

    renderContent() {
        const {sessions} = this.state;

        return <Table
            sx={{
                "& .MuiTableRow-root:hover": {
                    backgroundColor: "primary.light"
                },
                border: 1,
                borderColor: 'grey.400'
            }}
        >
            <TableHead>
                <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Key</TableCell>
                    <TableCell>LastModified</TableCell>
                    <TableCell></TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {
                    sessions.map((session: any, index: number) => {
                        return <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{session.Key}</TableCell>
                            <TableCell>{session.LastModified}</TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        this.fetchSessionData(session.Key);
                                    }}
                                >
                                    View
                                </Button>
                            </TableCell>
                        </TableRow>
                    })
                }
            </TableBody>
        </Table>
    }

    render() {
        const {loading} = this.state;
        if (loading) {
            return <LoadingIndicator loadingTextPlaceholder="Fetching Data" loadingText={true} />;
        }

        const {classes} = this.props;
        return <Paper className="contentPadding">
            <Typography className={classes.paper} variant="h6">{`Session log for UID: ${this.state.userId}`}</Typography>
            {this.renderFilter()}
            {this.renderContent()}
            {this.renderDialog()}
            {this.renderDataDialog()}
        </Paper>
    }
}

const styles: any = () => ({
    paper: {
        padding: 8,
        backgroundColor: "black"
    },
});

export const PlayerSession = withStyles(styles)(PlayerSessiontMain);